var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('span',[_c('router-link',{attrs:{"to":"/post/17"}},[_vm._v(" who are we ")])],1),_c('span',[_c('router-link',{attrs:{"to":"/post/18"}},[_vm._v(" Usage Agreement ")])],1),_c('span',[_c('router-link',{attrs:{"to":"/post/19"}},[_vm._v(" Privacy policy ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }